"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
var _chat = require('shared/enum/chat');
var _phone = require('shared/services/phone');


// How a message leaves the composer. It is fixed when the chat is created:
// only an SMS patient chat goes out as a plain text message.


 const PLAIN_SMS_LABEL = 'Plain SMS'; exports.PLAIN_SMS_LABEL = PLAIN_SMS_LABEL
 const SECURE_CHAT_LABEL = 'Secure chat'; exports.SECURE_CHAT_LABEL = SECURE_CHAT_LABEL
// The client can't know the shared number's digits.
 const SHARED_NUMBER_LABEL = 'Shared number'; exports.SHARED_NUMBER_LABEL = SHARED_NUMBER_LABEL

 const composerChannelFor = (conversationType) =>
  conversationType === _chat.CHAT_TYPE.REGULAR_PATIENT ? 'sms' : 'secure'; exports.composerChannelFor = composerChannelFor







 const channelLineText = ({ channel, sendingNumber }) => {
  if (channel === 'secure') return exports.SECURE_CHAT_LABEL
  if (_optionalChain([sendingNumber, 'optionalAccess', _ => _.kind]) === 'shared') return `${exports.PLAIN_SMS_LABEL} · ${exports.SHARED_NUMBER_LABEL}`
  if (_optionalChain([sendingNumber, 'optionalAccess', _2 => _2.kind]) !== 'team') return exports.PLAIN_SMS_LABEL
  const { Name, PhoneNumber } = sendingNumber.team
  return [exports.PLAIN_SMS_LABEL, Name, _phone.formatPhoneNumber.call(void 0, PhoneNumber)].filter(Boolean).join(' · ')
}; exports.channelLineText = channelLineText
